/**
 * GA4 event helpers.
 * These use window.gtag which is loaded by Firebase SDK (lib/firebase.ts).
 * No separate Measurement ID needed — Firebase provides it via NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID.
 */

export function trackEvent(
  action: string,
  category: string,
  label?: string,
  value?: number
): void {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value,
  });
}

export function trackBeginCheckout(params: {
  value: number;
  currency: string;
  items: Array<{ item_id: string; item_name: string; price: number }>;
}): void {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', 'begin_checkout', params);
}

export function trackPurchase(params: {
  transaction_id: string;
  value: number;
  currency: string;
  items: Array<{ item_id: string; item_name: string; price: number }>;
}): void {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', 'purchase', params);
}

export function trackContactFormSubmit(): void {
  trackEvent('submit', 'contact_form', 'contact_page');
}
